// import React, { useEffect, useState } from "react";

// import Navbar from "../component/Navbar";
// import Footer from "./Footer";
// import { Leader } from "../api/hitapi";
// import "../css/profile.css";

// const Leaderboard = () => {
//   const [list, setList] = useState([]);
  
//   useEffect(() => {
//     Leader().then((response) => {
//       console.log("LeaderBoardScore", response);
    
//       setList(response.data.Score);
//     });
//   }, []);
//   return (
//     <>
//       <div>
//         <Navbar />
//         {/* Search Overlay */}
//         <div className="search-overlay">
//           <div className="d-table">
//             <div className="d-table-cell">
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-close">
//                 <span className="search-overlay-close-line" />
//                 <span className="search-overlay-close-line" />
//               </div>
//               <div className="search-overlay-form">
//                 <form>
//                   <input
//                     type="text"
//                     className="input-search"
//                     placeholder="Search here..."
//                   />
//                   <button type="submit">
//                     <i className="flaticon-search-1" />
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* End Search Overlay */}
//         {/* Start Page Title Area */}
//         <section className="page-title-area page-title-bg1">
//           <div className="container">
//             <div className="page-title-content">
//               <br />
//               <h1 title="Sarah Taylor" style={{ color: "white" }}>
//                 LEADERBOARD
//               </h1>
//             </div>
//           </div>
//         </section>
//         {/* End Page Title Area */}
//         {/* Start Player Details Area */}
//         <section
//           className="player-details-area ptb-100"
//           style={{ color: "white" }}
//         >
//           <div className="container">
//             <div class="leader-bord-header">
//               <div class="leader-bord-header-inner"><span>Profile</span></div>
//               <div class="leader-bord-header-inner"><span>Name</span></div>
//               <div class="leader-bord-header-inner"><span>Score</span></div>
//             </div>
//             <div className="player-details-area-inner">
//               {list.map((item, index) => {
//                 return(
//                 <div className="player-details-area-box">
//                   <div className="schedule-box">
                   
//                     <div className="content leader-bord">
//                       <div className="time leader-bord-img">
//                         <img src={item.imageName} class="player-image" alt="im" />
//                       </div>
//                       <div className="leader-box-inner-name">
//                         <span>{item.name}</span>
//                       </div>
//                       <div className="leader-border-score">                        
//                         <span className="score-add">{index+1} Rank</span>
//                         <h3>{item.score}</h3>
//                       </div>
                      
//                     </div>

//                     <a href="#!" className="link-btn" />
//                   </div>
//                 </div>
//                 );
//               })}

             
//             </div>
//           </div>
//         </section>
//         {/* End Player Details Area */}
//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Leaderboard;




// import React, { useEffect, useState } from "react";
// import Navbar from "../component/Navbar";
// import Footer from "./Footer";
// import { getHistory } from "../api/hitapi";
// import "../css/profile.css";
// import Cookies from "js-cookie";

// const Leaderboard = () => {
//   const [list, setList] = useState([]);
//   const msisdn = Cookies.get("ani");

//   useEffect(() => {
//     if (!msisdn) return;

//     getHistory(msisdn)
//       .then((response) => {
//         console.log("History Response", response);
//         setList(response || []);
//       })
//       .catch((err) => {
//         console.error("History Error", err);
//       });
//   }, [msisdn]);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "-";
//     const d = new Date(dateStr);
//     return d.toLocaleString();
//   };

//   return (
//     <>
//       <div>
//         <Navbar />

//         {/* Search Overlay */}
//         <div className="search-overlay">
//           <div className="d-table">
//             <div className="d-table-cell">
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-close">
//                 <span className="search-overlay-close-line" />
//                 <span className="search-overlay-close-line" />
//               </div>
//               <div className="search-overlay-form">
//                 <form>
//                   <input
//                     type="text"
//                     className="input-search"
//                     placeholder="Search here..."
//                   />
//                   <button type="submit">
//                     <i className="flaticon-search-1" />
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Page Title */}
//         <section className="page-title-area page-title-bg1">
//           <div className="container">
//             <div className="page-title-content">
//               <br />
//               <h1 style={{ color: "white" }}>SPIN HISTORY</h1>
//             </div>
//           </div>
//         </section>

//         {/* History Table */}
//         <section className="player-details-area ptb-100" style={{ color: "white" }}>
//           <div className="container">

//             {/* User info */}
//             <div
//               style={{
//                 marginBottom: "20px",
//                 padding: "12px 16px",
//                 background: "rgba(255,255,255,0.05)",
//                 borderRadius: "8px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <i className="flaticon-network" style={{ fontSize: "20px" }} />
//               <span style={{ fontSize: "15px", fontWeight: "600" }}>
//                 User: <span style={{ color: "#c9a0ff" }}>{msisdn || "-"}</span>
//               </span>
//             </div>

//             {/* Table header */}
//             <div className="leader-bord-header">
//               <div className="leader-bord-header-inner"><span>#</span></div>
//               <div className="leader-bord-header-inner"><span>Reward Type</span></div>
//               <div className="leader-bord-header-inner"><span>Reward Points</span></div>
//               <div className="leader-bord-header-inner"><span>Spin Time</span></div>
//             </div>

//             {/* Rows */}
//             <div className="player-details-area-inner">
//               {list.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa" }}>
//                   No spin history found.
//                 </div>
//               ) : (
//                 list.map((item, index) => (
//                   <div key={index} className="player-details-area-box">
//                     <div className="schedule-box">
//                       <div className="content leader-bord">

//                         {/* # */}
//                         <div className="time leader-bord-img">
//                           <span style={{ fontWeight: "700", fontSize: "16px" }}>
//                             {index + 1}
//                           </span>
//                         </div>

//                         {/* Reward Type */}
//                         <div className="leader-box-inner-name">
//                           <span>{item.rewardType || "-"}</span>
//                         </div>

//                         {/* Reward Points */}
//                         <div className="leader-box-inner-name">
//                           <span
//                             style={{
//                               color: "#c9a0ff",
//                               fontWeight: "600",
//                               fontSize: "15px",
//                             }}
//                           >
//                             {item.rewardPoints ?? "-"}
//                           </span>
//                         </div>

//                         {/* Spin Time */}
//                         <div className="leader-border-score">
//                           <span className="score-add">
//                             {formatDate(item.spinTime)}
//                           </span>
//                         </div>

//                       </div>
//                       <a href="#!" className="link-btn" />
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>

//           </div>
//         </section>

//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Leaderboard;




// import React, { useEffect, useState } from "react";
// import Navbar from "../component/Navbar";
// import Footer from "./Footer";
// import { getHistory } from "../api/hitapi";
// import "../css/profile.css";
// import Cookies from "js-cookie";

// const Leaderboard = () => {
//   const [list, setList] = useState([]);
//   const msisdn = Cookies.get("ani");

//   useEffect(() => {
//     if (!msisdn) return;
//     getHistory(msisdn)
//       .then((response) => {
//         console.log("History Response", response);
//         setList(response || []);
//       })
//       .catch((err) => console.error("History Error", err));
//   }, [msisdn]);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "—";
//     const d = new Date(dateStr);
//     return (
//       d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) +
//       "  " +
//       d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
//     );
//   };

//   return (
//     <>
//       <div>
//         <Navbar />

//         {/* Search Overlay */}
//         <div className="search-overlay">
//           <div className="d-table">
//             <div className="d-table-cell">
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-layer" />
//               <div className="search-overlay-close">
//                 <span className="search-overlay-close-line" />
//                 <span className="search-overlay-close-line" />
//               </div>
//               <div className="search-overlay-form">
//                 <form>
//                   <input type="text" className="input-search" placeholder="Search here..." />
//                   <button type="submit">
//                     <i className="flaticon-search-1" />
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Page Title */}
//         <section className="page-title-area page-title-bg1">
//           <div className="container">
//             <div className="page-title-content">
//               <br />
//               <h1 style={{ color: "white" }}>Spin History</h1>
//             </div>
//           </div>
//         </section>

//         {/* History Section */}
//         <section className="player-details-area ptb-100" style={{ color: "white" }}>
//           <div className="container">

//             {/* User pill */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 background: "rgba(255,255,255,0.07)",
//                 border: "0.5px solid rgba(255,255,255,0.15)",
//                 borderRadius: "8px",
//                 padding: "8px 14px",
//                 marginBottom: "20px",
//                 fontSize: "13px",
//                 color: "rgba(255,255,255,0.6)",
//               }}
//             >
//               <i className="flaticon-network" style={{ fontSize: "25px" }} />
//               User:{" "}
//               <span style={{ fontWeight: "500", color: "white" }}>
//                 {msisdn || "—"}
//               </span>
//             </div>

//             {/* Table */}
//             <div
//               style={{
//                 width: "100%",
//                 overflowX: "auto",
//                 borderRadius: "12px",
//                 border: "0.5px solid rgba(255,255,255,0.12)",
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   tableLayout: "fixed",
//                   minWidth: "500px",
//                 }}
//               >
//                 {/* Column widths */}
//                 <colgroup>
//                   <col style={{ width: "44px" }} />
//                   <col style={{ width: "30%" }} />
//                   <col style={{ width: "22%" }} />
//                   <col />
//                 </colgroup>

//                 <thead>
//                   <tr style={{ borderBottom: "0.5px solid rgba(255,255,255,0.15)" }}>
//                     {["#", "Reward type", "Reward points", "Spin time"].map((h) => (
//                       <th
//                         key={h}
//                         style={{
//                           textAlign: "left",
//                           padding: "12px 14px",
//                           fontSize: "11px",
//                           fontWeight: "500",
//                           textTransform: "uppercase",
//                           letterSpacing: "0.05em",
//                           color: "rgba(255,255,255,0.45)",
//                         }}
//                       >
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {list.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={4}
//                         style={{
//                           textAlign: "center",
//                           padding: "48px 0",
//                           color: "rgba(255,255,255,0.35)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         No spin history found.
//                       </td>
//                     </tr>
//                   ) : (
//                     list.map((item, index) => (
//                       <tr
//                         key={index}
//                         style={{
//                           borderBottom:
//                             index < list.length - 1
//                               ? "0.5px solid rgba(255,255,255,0.08)"
//                               : "none",
//                         }}
//                       >
//                         {/* # */}
//                         <td
//                           style={{
//                             padding: "14px",
//                             fontSize: "12px",
//                             color: "rgba(255,255,255,0.35)",
//                           }}
//                         >
//                           {index + 1}
//                         </td>

//                         {/* Reward Type */}
//                         <td style={{ padding: "14px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               fontSize: "12px",
//                               fontWeight: "500",
//                               padding: "4px 12px",
//                               borderRadius: "100px",
//                               background: "rgba(201,160,255,0.15)",
//                               color: "#c9a0ff",
//                             }}
//                           >
//                             {item.rewardType || "—"}
//                           </span>
//                         </td>

//                         {/* Reward Points */}
//                         <td
//                           style={{
//                             padding: "14px",
//                             fontWeight: "500",
//                             fontSize: "15px",
//                             color: "#7fb3ff",
//                           }}
//                         >
//                           {item.rewardPoints ?? "—"}
//                         </td>

//                         {/* Spin Time */}
//                         <td
//                           style={{
//                             padding: "14px",
//                             fontSize: "12px",
//                             color: "rgba(255,255,255,0.5)",
//                           }}
//                         >
//                           {formatDate(item.spinTime)}
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>

//           </div>
//         </section>

//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Leaderboard;



// import React, { useEffect, useState } from "react";
// import Navbar from "../component/Navbar";
// import Footer from "./Footer";
// import { getHistory } from "../api/hitapi";
// import Cookies from "js-cookie";

// const Leaderboard = () => {
//   const [list, setList] = useState([]);
//   const msisdn = Cookies.get("ani");

//   useEffect(() => {
//     if (!msisdn) return;

//     getHistory(msisdn)
//       .then((response) => {
//         console.log("History Response", response);
//         setList(response || []);
//       })
//       .catch((err) => console.error("History Error", err));
//   }, [msisdn]);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "—";

//     const d = new Date(dateStr);

//     return (
//       d.toLocaleDateString(undefined, {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       }) +
//       " • " +
//       d.toLocaleTimeString(undefined, {
//         hour: "2-digit",
//         minute: "2-digit",
//       })
//     );
//   };

//   return (
//     <>
//       <Navbar />

//       {/* Page Banner */}
//       <section
//         className="relative py-24 overflow-hidden"
//         style={{
//           background:
//             "linear-gradient(180deg, #1a1035 0%, #0f071f 50%, #090412 100%)",
//         }}
//       >
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#7c3aed25,transparent_50%)]" />

//         <div className="container mx-auto px-4 relative z-10">
//           <div className="text-center">
//             <h1 className="text-white text-4xl md:text-5xl font-bold">
//               Spin History
//             </h1>
//             <p className="text-white/60 mt-3">
//               View all your wheel spin rewards
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* History Section */}
//       <section className="py-16 bg-[#090412] min-h-screen text-white">
//         <div className="container mx-auto px-4">
//           {/* User Card */}
//           <div className="mb-6">
//             <div className="inline-flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md px-5 py-3">
//               <i className="flaticon-network text-purple-400 text-lg"></i>

//               <span className="text-white/60 text-sm">User:</span>

//               <span className="font-semibold text-white">
//                 {msisdn || "—"}
//               </span>
//             </div>
//           </div>

//           {/* History Card */}
//           <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md overflow-hidden shadow-2xl">
//             {/* Header */}
//             <div className="px-6 py-3 border-b border-white/10">
//               <h2 className="text-xl font-semibold">Spin Records</h2>
//             </div>

//             {/* Mobile Cards */}
//             <div className="block lg:hidden">
//               {list.length === 0 ? (
//                 <div className="py-16 text-center text-white/40">
//                   No spin history found.
//                 </div>
//               ) : (
//                 <div className="p-2">
//                   {list.map((item, index) => (
//                     <div
//                       key={index}
//                       className="rounded-2xl border border-white/10 bg-white/5"
//                     >
//                       <div className="flex justify-between items-center">
//                         <span className="text-white/40 text-sm">
//                           #{index + 1}
//                         </span>

//                         <span className="bg-purple-500/20 text-purple-300 text-xs font-medium px-3 py-1 rounded-full">
//                           {item.rewardType || "—"}
//                         </span>
//                       </div>

//                       <div className="">
//                         <p className="text-white/50 text-xs uppercase">
//                           Reward Points
//                         </p>

//                         <p className="text-blue-400 font-bold text-xl">
//                           {item.rewardPoints ?? "—"}
//                         </p>
//                       </div>

//                       <div>
//                         <p className="text-white/50 text-xs uppercase">
//                           Spin Time
//                         </p>

//                         <p className="text-sm text-white/80">
//                           {formatDate(item.spinTime)}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Desktop Table */}
//             <div className="hidden lg:block overflow-x-auto">
//               <table className="w-full min-w-[700px]">
//                 <thead>
//                   <tr className="border-b border-white/10">
//                     <th className="px-6 text-left text-xs uppercase tracking-wider text-white/40 font-medium">
//                       #
//                     </th>

//                     <th className="px-6 py-4 text-left text-xs uppercase tracking-wider text-white/40 font-medium">
//                       Reward Type
//                     </th>

//                     <th className="px-6 py-4 text-left text-xs uppercase tracking-wider text-white/40 font-medium">
//                       Reward Points
//                     </th>

//                     <th className="px-6 py-4 text-left text-xs uppercase tracking-wider text-white/40 font-medium">
//                       Spin Time
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {list.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={4}
//                         className="py-16 text-center text-white/40"
//                       >
//                         No spin history found.
//                       </td>
//                     </tr>
//                   ) : (
//                     list.map((item, index) => (
//                       <tr
//                         key={index}
//                         className="border-b border-white/5 hover:bg-white/5 transition-all duration-300"
//                       >
//                         <td className="px-6 py-5 text-white/40">
//                           {index + 1}
//                         </td>

//                         <td className="px-6 py-5">
//                           <span className="inline-flex items-center rounded-full bg-purple-500/20 text-purple-300 px-4 py-1.5 text-sm font-medium">
//                             {item.rewardType || "—"}
//                           </span>
//                         </td>

//                         <td className="px-6 py-5">
//                           <span className="text-blue-400 font-bold text-lg">
//                             {item.rewardPoints ?? "—"}
//                           </span>
//                         </td>

//                         <td className="px-6 py-5 text-white/60">
//                           {formatDate(item.spinTime)}
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Stats */}
//           {list.length > 0 && (
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8">
//               <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6">
//                 <p className="text-white/50 text-sm">Total Spins</p>
//                 <h3 className="text-3xl font-bold mt-2">{list.length}</h3>
//               </div>

//               <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6">
//                 <p className="text-white/50 text-sm">Latest Reward</p>
//                 <h3 className="text-xl font-semibold mt-2 text-purple-300">
//                   {list[0]?.rewardType || "—"}
//                 </h3>
//               </div>

//               <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6">
//                 <p className="text-white/50 text-sm">Latest Points</p>
//                 <h3 className="text-3xl font-bold mt-2 text-blue-400">
//                   {list[0]?.rewardPoints ?? "—"}
//                 </h3>
//               </div>
//             </div>
//           )}
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default Leaderboard;



import React, { useEffect, useState } from "react";
import Navbar from "../component/Navbar";
import Footer from "./Footer";
import { getHistory } from "../api/hitapi";
import "../css/profile.css";
import Cookies from "js-cookie";

const Leaderboard = () => {
  const [list, setList] = useState([]);
  const msisdn = Cookies.get("ani");

  useEffect(() => {
    if (!msisdn) return;
    getHistory(msisdn)
      .then((response) => {
        console.log("History Response", response);
        setList(response || []);
      })
      .catch((err) => console.error("History Error", err));
  }, [msisdn]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return (
      d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) +
      " " +
      d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
    );
  };

  const thStyle = {
    textAlign: "left",
    padding: "10px 12px",
    fontSize: "16px",
    fontWeight: "800",
    color: "rgba(255,255,255,0.9)",
    whiteSpace: "nowrap",
  };

  const tdBase = {
    padding: "10px 12px",
    verticalAlign: "middle",
  };

  return (
    <>
      <div>
        <Navbar />

        {/* Search Overlay */}
        <div className="search-overlay">
          <div className="d-table">
            <div className="d-table-cell">
              <div className="search-overlay-layer" />
              <div className="search-overlay-layer" />
              <div className="search-overlay-layer" />
              <div className="search-overlay-close">
                <span className="search-overlay-close-line" />
                <span className="search-overlay-close-line" />
              </div>
              <div className="search-overlay-form">
                <form>
                  <input type="text" className="input-search" placeholder="Search here..." />
                  <button type="submit">
                    <i className="flaticon-search-1" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Page Title */}
        <section className="page-title-area page-title-bg1">
          <div className="container">
            <div className="page-title-content">
              <br />
              <h1 style={{ color: "white" }}>Spin History</h1>
            </div>
          </div>
        </section>

        {/* History Section */}
        <section className="player-details-area ptb-100" style={{ color: "white" }}>
          <div className="container">

            {/* User pill */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(255,255,255,0.07)",
                border: "0.5px solid rgba(255,255,255,0.15)",
                borderRadius: "8px",
                padding: "7px 14px",
                marginBottom: "14px",
                fontSize: "15px",
                fontWeight: "700",
                color: "rgba(255,255,255,0.7)",
              }}
            >
              <i className="flaticon-network" style={{ fontSize: "15px" }} />
              User:{" "}
              <span style={{ fontWeight: "800", color: "white" }}>
                {msisdn || "—"}
              </span>
            </div>

            {/* Responsive table wrapper */}
            <div style={{ width: "100%", overflowX: "auto", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.15)" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  minWidth: "420px",
                }}
              >
                <colgroup>
                  <col style={{ width: "40px" }} />
                  <col style={{ width: "28%" }} />
                  <col style={{ width: "24%" }} />
                  <col />
                </colgroup>

                {/* Header */}
                <thead>
                  <tr style={{ background: "rgba(255,255,255,0.08)", borderBottom: "1px solid rgba(255,255,255,0.2)" }}>
                    <th style={thStyle}>#</th>
                    <th style={thStyle}>Reward Type</th>
                    <th style={thStyle}>Points</th>
                    <th style={thStyle}>Spin Time</th>
                  </tr>
                </thead>

                {/* Body */}
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td
                        colSpan={4}
                        style={{
                          textAlign: "center",
                          padding: "40px 0",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "rgba(255,255,255,0.35)",
                        }}
                      >
                        No spin history found.
                      </td>
                    </tr>
                  ) : (
                    list.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          borderBottom:
                            index < list.length - 1
                              ? "0.5px solid rgba(255,255,255,0.1)"
                              : "none",
                        }}
                      >
                        {/* # */}
                        <td style={{ ...tdBase, fontSize: "15px", fontWeight: "700", color: "rgba(255,255,255,0.5)" }}>
                          {index + 1}
                        </td>

                        {/* Reward Type */}
                        <td style={tdBase}>
                          <span
                            style={{
                              display: "inline-block",
                              fontSize: "14px",
                              fontWeight: "800",
                              padding: "4px 14px",
                              borderRadius: "100px",
                              background: "rgba(201,160,255,0.18)",
                              color: "#d4aaff",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.rewardType || "—"}
                          </span>
                        </td>

                        {/* Reward Points */}
                        <td style={tdBase}>
                          <span style={{ fontSize: "20px", fontWeight: "800", color: "#7fb3ff", letterSpacing: "-0.5px" }}>
                            {item.rewardPoints ?? "—"}
                          </span>
                          <span style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "700", color: "rgba(127,179,255,0.6)" }}>
                            
                          </span>
                        </td>

                        {/* Spin Time */}
                        <td style={{ ...tdBase, fontSize: "14px", fontWeight: "700", color: "rgba(255,255,255,0.7)" }}>
                          {formatDate(item.spinTime)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Leaderboard;
